/**
 * Conversions
 * Umrechnung Tage/Std.: 1 Arbeitstag= 8.73 Stunden/1 Stunde = 0,115 Arbeitstage
 * Umrechnung Lektionen/Std.: 1 Lektion = 0.75 Std. = 0.086 Arbeitstage
 * Eine Arbeitswoche hat 5,5 Arbeitstage
 *
 * My Calc:
 * Hours = 1 / 8.73 = 0.1145475372279496
 * Lessons = (0.75 * 0.1145475372279496) / 1 = 0.0859106529209622
 * */

export const convertToDays = (val, format) => {
    if(format != 'days'){
        if(format == 'hours'){
            val = convertWorkHoursToDays(val);
        }else if(format == 'lessons'){
            val = convertWorkLessonsToDays(val);
        }
    }

    return val;
}
export const convertWorkHoursToDays = (hours) => {
    let days = parseFloat(hours) * 0.1145475372279496;

    return days;
}
export const convertWorkDaysToHours = (days) => {
    let hours = parseFloat(days) / 0.1145475372279496;

    return hours;
}
export const convertWorkLessonsToDays = (lessons) => {
    let days = parseFloat(lessons) * 0.0859106529209622;

    return days;
}
export const convertWorkDaysToLessons = (days) => {
    let lessons = parseFloat(days) / 0.0859106529209622;

    return lessons;
}

export const convertToNumber = (value) => {
    value = (value == 'NaN' || isNaN(value)) ? 0 : Number(value);
    return value;
}

export const convertForCalc = (value) => {
    if (value === '' || isNaN(value)) {
        return 0;
    }

    let decimals = 12;

    let number = Number.parseFloat(value);

    // Kaufmännische Runden for non-integer values
    let factor = Math.pow(10, decimals);
    number = Math.round(number * factor) / factor;
    number = number.toFixed(decimals);

    // Format the number with specified decimals
    return Number(number);
}
